import { render, staticRenderFns } from "./DeviceDeadRates.vue?vue&type=template&id=7a2483a9&scoped=true&"
import script from "./DeviceDeadRates.vue?vue&type=script&lang=js&"
export * from "./DeviceDeadRates.vue?vue&type=script&lang=js&"
import style0 from "./DeviceDeadRates.vue?vue&type=style&index=0&id=7a2483a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2483a9",
  null
  
)

export default component.exports